import { Perimeter } from "vue-kindergarten";

class BasePerimeter extends Perimeter {
  isSuperAdmin() {
    return this.child && this.child.role === "ROLE_SUPER_ADMIN";
  }
  isAdmin() {
    return this.child && this.child.role === "ROLE_ADMIN";
  }
  isClientAdmin() {
    return this.child && this.child.role === "ROLE_CLIENT_ADMIN";
  }
  isAgencyAdmin() {
    return this.child && this.child.role === "ROLE_AGENT_ADMIN";
  }
  isAgencyUser() {
    return this.child && this.child.role === "ROLE_AGENT_USER";
  }
  isClientAdmin() {
    return this.child && this.child.role === "ROLE_CLIENT_ADMIN";
  }
  isClientUser() {
    return this.child && this.child.role === "ROLE_CLIENT_USER";
  }
}

export default BasePerimeter;
